export const selectFeatureFlagsState = (state) =>
  state?.featureFlagsReducer || {};

export const selectFeatureFlags = (state) =>
  selectFeatureFlagsState(state)?.items || [];

export const selectFeatureFlagsLoading = (state) =>
  !!selectFeatureFlagsState(state)?.loading;

export const selectFeatureFlagsError = (state) =>
  selectFeatureFlagsState(state)?.error || null;

export const selectFeatureFlagUpdatingByName = (name) => (state) =>
  !!selectFeatureFlagsState(state)?.updatingByName?.[name];

export const selectFeatureFlagFetchingByName = (name) => (state) =>
  !!selectFeatureFlagsState(state)?.fetchingByName?.[name];
